import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const ItemTypes: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/addresstypes')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/itemsetup/addresstype/add', { state: { title: 'New address type', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/addresstypes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditAddressType)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Address types'
                                content={
                                    <DataTable
                                        name='dtAddressTypes'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Address type'
                                        navigateUrl='/plm/itemsetup/addresstype/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default ItemTypes;